import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import 'promise-polyfill/src/polyfill';
import './polyfills';
import './styles/main.sass';
import GoogleMapComponentWithMarker from './components/GoogleMapsWithMarker';
import Settings from './themes/allan-olsen/settings';
import Loader from './components/Loader';
import { getDataFromPath } from './data';
import TourList from './components/TourList';
import TMLogo from './styles/tmlogo.png';

const { PATH, TOPBANNER, MAP_HEIGHT_MOBILE, MAP_HEIGHT, SHOW_DUMMY_DATA } = Settings;

const App = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getDataFromPath(PATH, SHOW_DUMMY_DATA);
      setData(result);
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="app loading">
        <Loader />;
      </div>
    );
  }

  return (
    <div className="app">
      <header>
        <img src={TOPBANNER} className="topbanner" alt="" />
      </header>

      <GoogleMapComponentWithMarker
        settings={Settings}
        googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyB6qcikTYkn1KFlYigHQZHFE5rtaOtgk7c"
        loadingElement={
          <div style={{ height: isMobile ? MAP_HEIGHT_MOBILE : MAP_HEIGHT }}>
            <Loader />
          </div>
        }
        containerElement={<div style={{ height: isMobile ? MAP_HEIGHT_MOBILE : MAP_HEIGHT }} />}
        mapElement={<div style={{ height: isMobile ? MAP_HEIGHT_MOBILE : MAP_HEIGHT }} />}
        events={data}
      />
      <TourList events={data} />
      <img src={TMLogo} alt="Ticketmaster" className="tm-logo" />
    </div>
  );
};

export default App;
